import { useCallback } from 'react';
import { Typography } from '@material-ui/core';

import { CONFIRM_POPUP_MODE, useConfirmPopup } from 'src/components/ConfirmPopup';
import { RESTRICT_ACTION_TYPE, useErrorHandler, useRestrictActionPopup } from 'src/services/index';
import {
  useCustomerActions,
  useIsCurrentUserAdmin,
  useNotificationActions,
  useWorkspaceActions,
} from 'src/store';

export const useDeleteWorkspace = () => {
  const confirmPopup = useConfirmPopup();
  const customerActions = useCustomerActions();
  const workspaceActions = useWorkspaceActions();
  const notificationActions = useNotificationActions();
  const handleError = useErrorHandler();
  const openRestrictActionPopup = useRestrictActionPopup();
  const isCurrentUserAdmin = useIsCurrentUserAdmin();

  return useCallback(
    (workspace) => {
      const currentWorkspaces = workspaceActions.getCurrentWorkspaces();
      if (!isCurrentUserAdmin) {
        openRestrictActionPopup({ actionType: RESTRICT_ACTION_TYPE.memberRestrictAccess });
        return;
      }
      if (currentWorkspaces.length === 1) {
        openRestrictActionPopup({ actionType: RESTRICT_ACTION_TYPE.deleteLastWorkspace });
        return;
      }

      const onConfirm = async () => {
        try {
          await workspaceActions.deleteWorkspace(workspace.id);
          notificationActions.displaySuccess(`Workspace '${workspace.name}' deleted`);
          customerActions.refreshCurrentCustomerFeatureLimit();
        } catch (error) {
          handleError(error);
        }
      };

      confirmPopup({
        mode: CONFIRM_POPUP_MODE.warning,
        title: 'Delete Workspace',
        content: (
          <Typography>
            Are you sure you want to delete <b>{workspace.name}</b> workspace?
            <br />
            All generated and saved content in this workspace will be lost.
          </Typography>
        ),
        buttons: {
          confirm: 'Delete workspace',
          cancel: 'Cancel',
        },
        onConfirm,
      });
    },
    [
      workspaceActions,
      isCurrentUserAdmin,
      confirmPopup,
      openRestrictActionPopup,
      notificationActions,
      customerActions,
      handleError,
    ]
  );
};
